import { GameManager } from "../manager/game_manager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SdkHandler{

    constructor()
    {
        //此函数会在SdkBridge.js中调用，可以忽略这里的警告
        //@ts-ignore
        window.onHandlerPlatformMsg = (jsonObj)=>
        {
            var functionName = jsonObj.functionName
            cc.log("functionName:" + functionName);
            if(functionName == "onExitGame")
            {
                //关闭游戏
            }else if(functionName == "preLoadGame")
            {
                //TO DO:预加载游戏
            }else if(functionName == "onHideGame")
            {
                //TO DO:游戏最小化或者最大化要做的事
                var isHideGame = jsonObj.params.isHide //隐藏或者重新显示
                cc.log("receive message isHideGame:" + isHideGame);
            }else if(functionName == "onChangeGame")
            {
                var gameName = jsonObj.params.gameName; 
                GameManager.changeGame(gameName)
            }
            else
            {
                cc.log("receive message :" + functionName + ", but the function unuse");
            }
        }
    }
}
